import { AlpineComponent } from 'alpinejs';
import { Components } from '@porscheofficial/cookie-consent-banner/src';
import CookieConsentBanner = Components.CookieConsentBanner;

export default (): AlpineComponent => ({
    init(): void {
        /* Update available Cookie Categories */
        const cookieConsentBannerElement: CookieConsentBanner = document.querySelector(
            'cookie-consent-banner',
        );

        const cookieConsentBannerWrapper = document.querySelector(
            '#cookie-consent-banner-wrapper',
        );


        cookieConsentBannerElement.availableCategories = [
            {
                description:
                    'Enable you to navigate and use the basic functions and to store preferences.',
                key: 'technically_required',
                label: 'Technically necessary cookies',
                isMandatory: true,
            }, 
            {
                description:
                    'Enable us to determine how visitors interact with our service in order to improve the user experience.',
                key: 'analytics',
                label: 'Analysis cookies',
            },
            {
                description:
                    'Enable us to offer and evaluate relevant content and interest-based advertising.',
                key: 'marketing',
                label: 'Marketing cookies',
            },
        ];
        
        const consentChanged = (event) => {
            const acceptedCategories = event?.detail?.acceptedCategories;
            console.log("consentChanged", acceptedCategories);
            // @ts-ignore
            window.dataLayer.push({
                'event': 'consentChanged',
                'acceptedCategories': acceptedCategories
            });
        }

        window.addEventListener("cookie_consent_preferences_restored", consentChanged);
        window.addEventListener("cookie_consent_preferences_updated", consentChanged);
        
        //prevent flickering on page load
        setTimeout(() => {
            cookieConsentBannerWrapper.classList.remove("d-none");
        }, 500)
    },
});